export const KPI_ACCENTS = [
    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
    'linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)',
    'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    'linear-gradient(135deg, #4e73df 0%, #224abe 100%)',
    'linear-gradient(135deg, #f6c23e 0%, #fd7e14 100%)',
    'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
    'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
    'linear-gradient(135deg, #5c6bc0 0%, #3949ab 100%)',
    'linear-gradient(135deg, #e83e8c 0%, #6f42c1 100%)',
];

export const DASHBOARD_SECTIONS = [
    {
        id: 'overview',
        title: 'Overview',
        description: 'Key clinic metrics at a glance',
        icon: 'bi-speedometer2',
        variant: 'kpi',
        stats: [
            { key: 'TODAYS_APPOINTMENTS', label: "Today's Appointments", icon: 'bi-calendar-check', linkTo: '/appointments' },
            { key: 'THIS_WEEKS_APPOINTMENTS', label: 'This Week', icon: 'bi-calendar-week', linkTo: '/appointments' },
            { key: 'ACTIVE_PATIENTS', label: 'Active Patients', icon: 'bi-people', linkTo: '/patient-files' },
            { key: 'NEW_PATIENTS_THIS_MONTH', label: 'New Patients', icon: 'bi-person-plus', linkTo: '/patient-files' },
            { key: 'MESSAGES_SENT_THIS_MONTH', label: 'Messages Sent', icon: 'bi-chat-dots', linkTo: '/messages' },
            { key: 'PENDING_WEB_BOOKINGS', label: 'Pending Bookings', icon: 'bi-calendar-plus', linkTo: '/web-bookings' },
            { key: 'UNREAD_SMS', label: 'Unread SMS', icon: 'bi-envelope-exclamation', linkTo: '/messages' },
            { key: 'FAILED_COMMUNICATIONS', label: 'Failed Comms', icon: 'bi-exclamation-triangle', linkTo: '/activity' },
            { key: 'REPUTATION_POSITIVE_RATE', label: 'Positive Feedback', icon: 'bi-emoji-smile', linkTo: '/reputation' },
            { key: 'ACTIVE_CAMPAIGNS', label: 'Active Campaigns', icon: 'bi-megaphone', linkTo: '/blast/email' },
        ],
    },
    {
        id: 'patients',
        title: 'Patients',
        description: 'Patient counts, contact coverage, and demographics',
        icon: 'bi-people-fill',
        linkTo: '/patient-files',
        linkLabel: 'Open patient files',
        stats: [
            { key: 'TOTAL_PATIENTS', label: 'Total Patients' },
            { key: 'INACTIVE_PATIENTS', label: 'Inactive Patients' },
            { key: 'PATIENTS_WITH_EMAIL', label: 'With Email' },
            { key: 'PATIENTS_EMAIL_PERCENT', label: 'Email Coverage (%)' },
            { key: 'PATIENTS_WITH_CELL_PHONE', label: 'With Cell Phone' },
            { key: 'PATIENTS_CELL_PHONE_PERCENT', label: 'Cell Phone Coverage (%)' },
            { key: 'PATIENTS_WITH_HOME_PHONE', label: 'With Home Phone' },
            { key: 'PATIENTS_HOME_PHONE_PERCENT', label: 'Home Phone Coverage (%)' },
            { key: 'WELCOME_SENT', label: 'Welcome Sent' },
            { key: 'PATIENTS_CHILDREN', label: 'Children (0–12)' },
            { key: 'PATIENTS_TEENAGER', label: 'Teenagers (13–18)' },
            { key: 'PATIENTS_ADULT', label: 'Adults (19–64)' },
            { key: 'PATIENTS_SENIOR', label: 'Seniors (65+)' },
            { key: 'PATIENTS_AGE_UNKNOWN', label: 'Age Unknown' },
            { key: 'INVALID_CONTACTS', label: 'Invalid Contacts' },
        ],
    },
    {
        id: 'appointments',
        title: 'Appointments & Reminders',
        description: 'Appointment volume and reminder delivery',
        icon: 'bi-calendar-event',
        linkTo: '/appointments',
        linkLabel: 'View appointments',
        stats: [
            { key: 'APPOINTMENTS_THIS_MONTH', label: 'Appointments This Month' },
            { key: 'APPOINTMENTS_CONFIRMED', label: 'Confirmed' },
            { key: 'APPOINTMENTS_UNCONFIRMED', label: 'Unconfirmed' },
            { key: 'REMINDERS_PREBOOKED_SENT', label: 'Prebooked Reminders Sent' },
            { key: 'REMINDERS_FIRST_SENT', label: 'First Reminders Sent' },
            { key: 'REMINDERS_SECOND_SENT', label: 'Second Reminders Sent' },
            { key: 'REMINDERS_LAST_SENT', label: 'Last-Day Reminders Sent' },
            { key: 'REMINDERS_SAME_DAY_SENT', label: 'Same-Day Reminders Sent' },
        ],
    },
    {
        id: 'communications',
        title: 'Communications',
        description: 'Outbound activity in the last 30 days',
        icon: 'bi-broadcast',
        linkTo: '/messages',
        linkLabel: 'View messages',
        stats: [
            { key: 'EMAIL_SENT', label: 'Emails Sent' },
            { key: 'SMS_SENT', label: 'SMS Sent' },
            { key: 'CALL_SENT', label: 'Calls Sent' },
            { key: 'EMAIL_SEND_FAILED', label: 'Email Failed' },
            { key: 'SMS_SEND_FAILED', label: 'SMS Failed' },
            { key: 'CALL_SEND_FAILED', label: 'Call Failed' },
            { key: 'APPOINTMENT_REMINDERS', label: 'Appointment Reminders' },
            { key: 'FIRST_REMINDERS', label: 'First Reminders' },
            { key: 'SECOND_REMINDERS', label: 'Second Reminders' },
            { key: 'LAST_REMINDERS', label: 'Last-Day Reminders' },
            { key: 'SAME_DAY_REMINDERS', label: 'Same-Day Reminders' },
            { key: 'RECALL_REMINDERS', label: 'Recall Reminders' },
            { key: 'WELCOME_REMINDERS', label: 'Welcome Messages' },
            { key: 'PICKUPS_REMINDERS', label: 'Pickup Reminders' },
            { key: 'THANKYOU_REMINDERS', label: 'Thank-You Messages' },
        ],
    },
    {
        id: 'gateway',
        title: 'SMS Gateway',
        description: 'Two-way texting performance (last 30 days)',
        icon: 'bi-phone',
        linkTo: '/sms-dashboard',
        linkLabel: 'SMS gateway dashboard',
        stats: [
            { key: 'GATEWAY_TOTAL_MESSAGES', label: 'Total Messages' },
            { key: 'GATEWAY_MESSAGES_SENT', label: 'Sent' },
            { key: 'GATEWAY_MESSAGES_RECEIVED', label: 'Received' },
            { key: 'GATEWAY_MESSAGES_UNREAD', label: 'Unread' },
            { key: 'GATEWAY_MESSAGES_DELIVERED', label: 'Delivered' },
            { key: 'GATEWAY_MESSAGES_FAILED', label: 'Failed' },
            { key: 'GATEWAY_UNIQUE_PATIENTS', label: 'Unique Patients' },
            { key: 'GATEWAY_SENT_SUCCESS_RATE', label: 'Success Rate (%)' },
            { key: 'GATEWAY_READ_RATE', label: 'Read Rate (%)' },
        ],
    },
    {
        id: 'bookings',
        title: 'Web Bookings',
        description: 'Online appointment request pipeline',
        icon: 'bi-globe',
        linkTo: '/web-bookings',
        linkLabel: 'Manage bookings',
        stats: [
            { key: 'WEB_BOOKINGS_FOLLOWUP', label: 'Follow-Up Needed' },
            { key: 'WEB_BOOKINGS_PROCESSED', label: 'Processed' },
            { key: 'WEB_BOOKINGS_NEW_PATIENT', label: 'New Patient Requests' },
            { key: 'WEB_BOOKINGS_RETURNING_PATIENT', label: 'Returning Patient Requests' },
        ],
    },
    {
        id: 'campaigns',
        title: 'Campaigns',
        description: 'Blasts, newsletters, and campaign health',
        icon: 'bi-megaphone-fill',
        linkTo: '/blast/email',
        linkLabel: 'View campaigns',
        stats: [
            { key: 'CAMPAIGNS_TOTAL', label: 'Total Campaigns' },
            { key: 'TODAYS_CAMPAIGN', label: 'Created Today' },
            { key: 'CAMPAIGNS_COMPLETED', label: 'Completed' },
            { key: 'CAMPAIGNS_ERROR', label: 'Errors' },
        ],
    },
    {
        id: 'recalls',
        title: 'Recalls',
        description: 'Recall file processing status',
        icon: 'bi-arrow-repeat',
        linkTo: '/my-files',
        linkLabel: 'View recall files',
        stats: [
            { key: 'RECALL_REQUESTS_PENDING', label: 'Pending' },
            { key: 'RECALL_REQUESTS_IN_PROCESS', label: 'In Process' },
            { key: 'RECALL_REQUESTS_COMPLETED', label: 'Completed' },
            { key: 'RECALL_REQUESTS_FAILED', label: 'Failed' },
        ],
    },
    {
        id: 'reputation-enhancement',
        title: 'Reputation Enhancement',
        description: 'Patient sentiment feedback and pending review comments',
        icon: 'bi-star-half',
        linkTo: '/reputation',
        linkLabel: 'Open reputation enhancement',
        stats: [
            { key: 'REPUTATION_FEEDBACK_TOTAL', label: 'Total Feedback' },
            { key: 'REPUTATION_FEEDBACK_POSITIVE', label: 'Positive' },
            { key: 'REPUTATION_FEEDBACK_NEUTRAL', label: 'Neutral' },
            { key: 'REPUTATION_FEEDBACK_NEGATIVE', label: 'Negative' },
            { key: 'REPUTATION_POSITIVE_RATE', label: 'Positive Rate (%)' },
            { key: 'REPUTATION_COMMENTS_PENDING', label: 'Pending Comments' },
        ],
    },
    {
        id: 'pms',
        title: 'PMS Sync',
        description: 'Practice management sync results this month',
        icon: 'bi-cloud-arrow-down',
        linkTo: '/pms-update-history',
        linkLabel: 'Sync history',
        stats: [
            { key: 'PMS_SYNC_SUCCESS_THIS_MONTH', label: 'Successful Syncs' },
            { key: 'PMS_SYNC_ERROR_THIS_MONTH', label: 'Failed Syncs' },
        ],
    },
    {
        id: 'staff',
        title: 'Staff & Setup',
        description: 'Team accounts and communication templates',
        icon: 'bi-gear-fill',
        linkTo: '/settings/users',
        linkLabel: 'Manage users',
        stats: [
            { key: 'STAFF_TOTAL', label: 'Total Staff' },
            { key: 'STAFF_MANAGERS', label: 'Managers' },
            { key: 'STAFF_ECPS', label: 'ECPs' },
            { key: 'STAFF_MEMBERS', label: 'Staff Users' },
            { key: 'STAFF_BLOCKED', label: 'Blocked Users' },
            { key: 'EMAIL_TEMPLATES', label: 'Email Templates' },
            { key: 'SMS_TEMPLATES', label: 'SMS Templates' },
            { key: 'CALL_TEMPLATES', label: 'Call Templates' },
        ],
    },
];

export const buildStatsMap = (stats = []) =>
    stats.reduce((acc, stat) => {
        if (stat?.statsName) {
            acc[stat.statsName] = stat.statsValue ?? '0';
        }
        return acc;
    }, {});

export const getLatestStatTimestamp = (stats = []) => {
    if (!stats.length) {
        return null;
    }

    const timestamps = stats
        .map((stat) => stat.modifiedAt || stat.createdAt)
        .filter(Boolean)
        .sort()
        .reverse();

    return timestamps[0] || null;
};
